import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { translateFn } from '../../../utils/translator.helper';
import { html } from 'lit';
import { DownloadTypes, KitIds } from '../constants';
import { Feature } from '@nirvana/shared/constants';

export class DownloadKitButtonSelectorView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$megaMenuOverlay = this.shadow.querySelector('#mega-menu-overlay');
    this.dom.$megaMenuButton = this.shadow.querySelector('#mega-menu-button');
    this.dom.$megaMenuButtonTextContainer = this.shadow.querySelector('#download-package-actions-split-button-text');
    this.dom.$megaMenuContainer = this.shadow.querySelector('#mega-menu-container');
  }

  buildSuccessView(data: any) {
    this.dom.$megaMenuButtonTextContainer.innerText = translateFn('Download');
  }
}
